import { ReactNode } from "react";
import { Button, IconButton, styled } from "@mui/material";
import { COMPACT_FLOATING_BUTTON_SIZE } from "@rentablo/components";

export const ActionIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "boxed",
})<{ boxed?: boolean }>(({ theme, boxed }) => ({
  ...(boxed && {
    width: COMPACT_FLOATING_BUTTON_SIZE,
    height: COMPACT_FLOATING_BUTTON_SIZE,
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.border.primary}`,
  }),
}));

interface AdaptiveButtonProps {
  iconOnly?: boolean;
  icon: ReactNode;
  label: string;
  testId?: string;
  onClick?: () => void;
}

export const AdaptiveButton = ({
  iconOnly,
  icon,
  label,
  testId,
  onClick,
}: AdaptiveButtonProps) =>
  iconOnly ? (
    <ActionIconButton
      boxed
      color="secondary"
      data-testid={testId}
      aria-label={label}
      onClick={onClick}
    >
      {icon}
    </ActionIconButton>
  ) : (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      startIcon={icon}
      data-testid={testId}
      onClick={onClick}
    >
      {label}
    </Button>
  );
